import { render } from "./UnregisterCompleteEnd.vue?vue&type=template&id=281b00c0"
import script from "./UnregisterCompleteEnd.vue?vue&type=script&lang=js"
export * from "./UnregisterCompleteEnd.vue?vue&type=script&lang=js"

import "./UnregisterCompleteEnd.vue?vue&type=style&index=0&id=281b00c0&lang=css"
script.render = render

export default script